module.exports = __webpack_public_path__ + "static/media/gain_risk.306b3ee2.png";